import * as React from 'react';
import PropTypes from 'prop-types';
import { Stack, Button } from '@mui/material';
import { cores } from '../styles/styleUtils';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '70vw',
  height: '98vh',
  '@media screen and (max-width: 600px)': {
    width: '100vw', // Width de 100% para telas de celulares
    height: '95vh',
  },
  bgcolor: 'transparent',
  border: `1px solid ${cores.chumbo}`,
  borderTop: `4px solid ${cores.laranja}`,
  boxShadow: 24,
  p: 2,
  overflowY: 'auto',
  background: `linear-gradient(180deg, ${cores.painelTopo} 0%, ${cores.painelBase} 100%)`,
  justifyContent: 'center',
  alignItems: 'center',
  color: cores.textoClaro,
};

// ----------------------------------------------------------------------
// eslint-disable-next-line
const EditFluxoSemAcesso = React.forwardRef((props, ref) => {

  
  return (
    <>
      <Stack sx={style}>
        Sem acesso nesse fluxo, acompanhe as etapas pelo Kanban
        <Button sx={{mt: 2}} variant="outlined" onClick={() => props.onClose()} color="error"> Voltar</Button>
      </Stack>
      
    </>
      
  );
})

EditFluxoSemAcesso.propTypes = {
  produto: PropTypes.object,
  onConfirm: PropTypes.func,
  open: PropTypes.bool,
  handleClose: PropTypes.func,
  onClose: PropTypes.func,
}

export default (EditFluxoSemAcesso);